export default ({}) => {
    return {
        xAxis: {
            visible: false,
        },
    };
};
